module.exports = __webpack_public_path__ + "img/rank11.6b79783b.png";